import './App.css';


import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import TipCalculator from "./TipCalculator/TipCalculator.js"
import {Recipes, Recipe} from "./Recipes/Recipes.js"

function App() {
  return (
    <Router>
      {/* Usually you'd have a navigation bar here, e.g. <NavBar /> */}
      <Routes>
        <Route path="/" element={<Welcome />} />
        
        <Route path="/TipCalculator" element={<TipCalculator />} />
        
        <Route path="/Recipes" element={<Recipes />} />
        <Route path="/Recipes/:recipeLabel" element={<Recipe />} />
      </Routes>
    </Router>
  );
}


function Welcome() {
  const divStyle = {
    margin: "20px" ,
  }
  const linkStyle = {
    textDecoration: null ,
  }
  
  document.title = "Site of Things"
  
  return (
    <div style={divStyle}>
      <p>
        <Link style={linkStyle} to="/TipCalculator" target="_self">Tip Calculator/Optimizer</Link>
      </p>
      
      <p>
        <a style={linkStyle} href="/security/questions.html" target="_self">Security-Question Answer Generator</a>
      </p>
      
      <p>
        <Link style={linkStyle} to="/Recipes" target="_self">Recipes</Link>
      </p>
      
    </div>
  )
}

export default App;
